"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
//TODO: Use specific imports
const lodash_1 = __importDefault(require("lodash"));
const MarketList_1 = __importDefault(require("./MarketList"));
const outsideCoverageId = 'outside_coverage';
const outsideCoverageRegion = {
    identifier: outsideCoverageId,
    details: { displayName: 'Outside Coverage', postalCodes: [], buyBoxPostalCodes: [] },
};
const ZipcodeList = ({ markets, activeMarket, selectedZipCodes, onZipCodeSelect, onZipCodeUnselect, trackedMarketIdentifier, setTrackedMarketIdentifier, }) => {
    const [zipcodesAndMarkets, setZipcodesAndMarkets] = react_1.useState({});
    react_1.default.useEffect(() => {
        setZipcodesAndMarkets(lodash_1.default(markets)
            .flatMapDepth((market) => { var _a; return (_a = market.details) === null || _a === void 0 ? void 0 : _a.postalCodes.map((zipcode) => [zipcode, market]); }, 1)
            .fromPairs()
            .value());
    }, [markets]);
    const marketFor = (zipcode) => { var _a, _b; return (_b = (_a = zipcodesAndMarkets[zipcode]) === null || _a === void 0 ? void 0 : _a.identifier) !== null && _b !== void 0 ? _b : outsideCoverageId; };
    const marketsAndSelectedZipcodes = lodash_1.default(selectedZipCodes)
        .map((zipcode) => ({ market: marketFor(zipcode), zipcode }))
        .groupBy('market')
        .value();
    const renderMarketList = (market, active) => {
        const selectedMarketZipCodes = (marketsAndSelectedZipcodes[market.identifier] || [])
            .map((marketAndZipcode) => marketAndZipcode.zipcode)
            .sort();
        const isMarketTracked = trackedMarketIdentifier === market.identifier;
        return (react_1.default.createElement(MarketList_1.default, { market: market, selectedZipCodes: selectedMarketZipCodes, onZipCodeSelect: onZipCodeSelect, onZipCodeUnselect: onZipCodeUnselect, expand: active, onTrackedToggled: () => setTrackedMarketIdentifier(isMarketTracked ? undefined : market.identifier), tracked: isMarketTracked, disabled: !isMarketTracked && !!trackedMarketIdentifier }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { variant: "body1", gutterBottom: true }, "Zip code list"),
        react_1.default.createElement("div", { className: "overflow-y-scroll", style: { flexGrow: 1, maxHeight: '80vh' } },
            markets.map((market) => renderMarketList(market, market.identifier === activeMarket.identifier)),
            renderMarketList(outsideCoverageRegion, false))));
};
exports.default = ZipcodeList;
